import React, { Component } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { connect } from 'react-redux';
import { ModuleRegistry } from 'ag-grid-community';
import { CheckboxEditorModule } from 'ag-grid-community';
import { Input, Form, FormGroup, Label } from 'reactstrap';
import IndiSaltoRoom from './indiSaltoFold/IndiSaltoRoom';
import IndiSaltoClass from './indiSaltoFold/IndiSaltoClass';
import IndiSaltoIndiv from './indiSaltoFold/IndiSaltoIndiv';

ModuleRegistry.registerModules([CheckboxEditorModule]); 

class IndiSalto extends Component {
    static displayName = IndiSalto.name;

    constructor(props) {
        super(props)
        this.state = {
            bearerVAR: "Bearer " + this.props.reduxData.apiKey,
            permissionData: true,
            activeChild: "class"
        }
        this.testPermission();
    }

    async testPermission() {
        this.props.updateFetchTime()
        let toSend = {
            userLevel: this.props.reduxData.userInfo.level.pk,
            pagepk: "/IndividualSalto"
        }
        const response = await fetch("ValidDepartments", {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': this.state.bearerVAR },
            body: JSON.stringify(toSend)
        })
        const data = await response.json()
        this.setState({
            permissionFlag: data
        })
    }

    flipChildComponent(param) {
        this.setState({
            activeChild: param
        })
    }

    render() {
        if (this.state.permissionFlag == false) {
            this.props.passNewPage(-1);
        }
        let displayChild = <div></div>
        switch (this.state.activeChild) {
            case "room":
                displayChild = <IndiSaltoRoom />
                break;
            case "class":
                displayChild = <IndiSaltoClass />
                break;
            case "indi":
                displayChild = <IndiSaltoIndiv />
                break;
            default:
                break;
        }
        return (<div>
            <Form className="rightAlignCustom">
                {this.props.reduxData.userInfo.level.pk == 282 &&  <FormGroup check inline>
                    <Input checked={this.state.activeChild == "room" ? true : false} type="radio" name="saltoFlip" id="saltoFlip" onChange={() => this.flipChildComponent("room")} />
                    <Label>Classroom</Label>
                </FormGroup>}
                <FormGroup check inline>
                    <Input checked={this.state.activeChild == "class" ? true : false} type="radio" name="saltoFlip" id="saltoFlip" onChange={() => this.flipChildComponent("class")} />
                    <Label>Course</Label>
                </FormGroup>
                <FormGroup check inline>
                    <Input checked={this.state.activeChild == "indi" ? true : false} type="radio" name="saltoFlip" id="saltoFlip" onChange={() => this.flipChildComponent("indi")} />
                    <Label>Individual</Label>
                </FormGroup>
            </Form>
            <br />
            {displayChild }
        </div>)
    }
}

const mapStateTo = state => ({
    reduxData: state
})

const mapDispatchTo = (dispatch) => {
    return {
        updateFetchTime: () => dispatch({ type: 'foundation/setFetchTime' })
    }
}

export default connect(mapStateTo, mapDispatchTo)(IndiSalto);